




































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import moment from 'moment'

@Component({
  components: {},
})
export default class DatetimePicker extends Mixins() {
  @Prop({
    type: [Date, String],
    default: null,
  })
  datetime: any

  @Prop({
    type: Boolean,
    default: false,
  })
  disabled!: boolean

  @Prop({
    type: Boolean,
  })
  loading!: boolean

  @Prop({
    type: String,
    default: '',
  })
  label!: string

  @Prop({
    type: Number,
    default: 340,
  })
  dialogWidth!: number

  @Prop({
    type: String,
    default: 'YYYY-MM-DD',
  })
  dateFormat: any

  @Prop({
    type: String,
    default: 'HH:mm',
  })
  timeFormat!: string

  @Prop({
    type: String,
    default: 'CLEAR',
  })
  clearText!: string

  @Prop({
    type: String,
    default: 'OK',
  })
  okText!: string

  @Prop({
    type: Object,
  })
  textFieldProps: any

  @Prop({
    type: Object,
  })
  datePickerProps: any

  @Prop({
    type: Object,
  })
  timePickerProps: any

  DEFAULT_DATE = ''

  DEFAULT_TIME = '00:00'

  DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'

  DEFAULT_TIME_FORMAT = 'HH:mm'

  DEFAULT_DIALOG_WIDTH = 340

  DEFAULT_CLEAR_TEXT = 'CLEAR'

  DEFAULT_OK_TEXT = 'OK'

  display = false

  activeTab = 0

  date = this.DEFAULT_DATE

  time = this.DEFAULT_TIME

  formattedDateTimeTextField = ''

  mounted() {
    console.log(this)
    console.log(this.datetime)
    this.init()
  }

  @Watch('datetime')
  startInit() {
    if (this.datetime) {
      this.formattedDateTimeTextField = this.datetime
    }
    this.init()
  }

  dateTimeFormat() {
    return `${this.dateFormat} ${this.timeFormat}`
  }

  defaultDateTimeFormat() {
    return `${this.DEFAULT_DATE_FORMAT} ${this.DEFAULT_TIME_FORMAT}`
  }

  selectedDatetime() {
    if (this.date && this.time) {
      return `${this.date} ${this.time}`
    }
    return ''
  }

  dateSelected() {
    return !this.date
  }

  init() {
    if (!this.datetime) {
      return
    }
    const initDateTime = moment(this.datetime, 'YYYY-MM-DD HH:mm')
    this.date = initDateTime.format(this.DEFAULT_DATE_FORMAT)
    this.time = initDateTime.format(this.DEFAULT_TIME_FORMAT)
    this.formattedDateTimeTextField = this.selectedDatetime()
  }

  okHandler() {
    this.resetPicker()
    this.formattedDateTimeTextField = this.selectedDatetime()
    this.$emit('input', this.selectedDatetime())
  }

  clearHandler() {
    this.resetPicker()
    this.date = this.DEFAULT_DATE
    this.time = this.DEFAULT_TIME
    this.$emit('input', null)
  }

  resetPicker() {
    this.formattedDateTimeTextField = ''
    this.display = false
    this.activeTab = 0
    if (this.$refs.timer) {
      ;(this.$refs.timer as any).selectingHour = true
    }
  }

  showTimePicker() {
    this.activeTab = 1
  }
}
